import { useMemo } from 'react';
import { useCurrentUser } from './useCurrentUser';
import useAsset from './useAsset';
export var useCanCreateRecurringProjects = function() {
    var user = useCurrentUser().user;
    var constants = useAsset().constants;
    var canCreateRecurring = useMemo(function() {
        if (!user) return false;
        var role = user.organization_membership.role;
        var is_managed = user.organization.is_managed;
        return !!is_managed && role === constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS || user.is_ops && role !== constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(user),
        constants
    ]);
    return {
        canCreateRecurring: canCreateRecurring
    };
};
